<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Recovery Account</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/accounts" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createAccount" v-if="account">
                <div class="row justify-content-md-center">
                    <div class="col-7">
                        <div class="row">
                          <div class="col-md-8">
                            <fg-input type="email"
                                      v-model="account.oldEmail"
                                      label="Old Email"
                                      placeholder="Enter Old Email"
                                      data-vv-name="oldEmail"
                                      cus-name="oldEmail"
                                      v-validate="rules.oldEmail"
                                      :has-errors="errors"
                                      :is-fields="fields"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-8">
                            <fg-input type="email"
                                      v-model="account.email"
                                      label="New Email"
                                      placeholder="Enter New Email"
                                      data-vv-name="email"
                                      cus-name="email"
                                      v-validate="rules.email"
                                      :has-errors="errors"
                                      :is-fields="fields"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-8">
                            <fg-input type="password"
                                      v-model="account.password"
                                      label="New Password (Min 6 Chars, One Upper Case, One Lower Case)"
                                      placeholder="Enter Password"
                                      data-vv-name="password"
                                      cus-name="password"
                                      v-validate="rules.password"
                                      :has-errors="errors"
                                      :is-fields="fields"
                            >
                            </fg-input> <div class="col-md-8"> <span v-if="account.password"><strong>Password: {{account.password}}</strong></span></div>
                          </div>
                        </div>
                    <div class="col-8 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Recover Account
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateAccount',
        created (){
    },
    data () {
        return {
            showMore: false,
            account: {
            oldEmail: '',
              email: '',
              password: ''
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              oldEmail: {required : true},
              email: {required: true},
              password: {required : true}
            },
            faqSections: [],
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      verifyPassword () {
        if (this.account.password.length >= 6) {
          let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
          if (!re.test(this.account.password)) {
            return false
          } else {
            return true
          }
        } else {
          if (this.account.password.length > 0) {
            return false
          } else {
            return true
          }
        }
      },
        createAccount () {
        if (!this.verifyPassword ()) {
          this.showPopup('Incorrent Password!', 'Min 6 Chars, One Upper Case, One Lower Case!', 'error')
        } else if (this.account.email.trim() === this.account.oldEmail.trim()) {
          this.showPopup('Incorrect New Email', 'New Email and Old should not be same', 'error')
        }
        else {
            console.log("this.article : ", this.account);
            this.$validator.validateAll().then((result) => {
              if(result){
                this.$store.dispatch('ADD_ACCOUNT', this.account)
                  .then((res) => {
                    console.log("ADD_ACCOUNT res : ", res);
                    if(res) this.showPopup('Success!', 'Account has been recovered successfully', 'success', ()=>this.$router.push('/admin/accounts'))
                    else this.showPopup('Error!', 'Unable to process.', 'error')
                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("ADD_ARTICLE API error : ", err);
                  })
              }
            })
          }
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/CreateAccount.vue